import React, { FC } from 'react'
import styled from 'styled-components'
import { ProgressBar as CosmaProgressBar } from 'is24-corecss'

type StyledProgressBarProps = {
  backgroundColor?: string
  progressColor?: string
  progress: number
}

const StyledProgressBar = styled.div`
  ${(props: StyledProgressBarProps) =>
    props.progressColor &&
    `
      div div div{
        background-color: ${props.progressColor}!important;
      }
  `}
  ${(props: StyledProgressBarProps) =>
    props.backgroundColor &&
    `
      div div{
        background-color: ${props.backgroundColor}!important;
      }
    `}
`

const ProgressBar: FC<StyledProgressBarProps> = (props: StyledProgressBarProps) => {
  return (
    <StyledProgressBar {...props} data-testid='test-progress'>
      <CosmaProgressBar progress={props.progress} />
    </StyledProgressBar>
  )
}

export { ProgressBar }
